import { NgModule } from '@angular/core';
import { MsContentFormComponent } from './ms-content-form.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';
import { MsButtonModule } from '../ms-button/ms-button.module';

@NgModule({
	declarations: [MsContentFormComponent],
	imports: [SharedLibsModule, MsButtonModule],
	exports: [MsContentFormComponent],
	providers: [],
})
export class MsContentFormModule {}
